import {
  CircleCheck,
  CircleQuestion,
  CircleXmark,
  TriangleExclamation,
} from "@gravity-ui/icons";
import { CardTheme, IconData, LabelProps } from "@gravity-ui/uikit";
import {
  PublicAlertSeverityEnum,
  StatusResponseOverallEnum,
} from "definitions/poizon-bff";

type LabelTheme = NonNullable<LabelProps["theme"]>;

interface StatusInfo {
  icon: IconData;
  badgeLabel: string;
  bannerTitle: string;
  labelTheme: LabelTheme;
  cardTheme: CardTheme;
}

export const statusInfo: Record<StatusResponseOverallEnum, StatusInfo> = {
  [StatusResponseOverallEnum.Operational]: {
    icon: CircleCheck,
    badgeLabel: "Работает",
    bannerTitle: "Все системы работают",
    labelTheme: "success",
    cardTheme: "success",
  },
  [StatusResponseOverallEnum.Degraded]: {
    icon: TriangleExclamation,
    badgeLabel: "Деградация",
    bannerTitle: "Частичная деградация",
    labelTheme: "warning",
    cardTheme: "warning",
  },
  [StatusResponseOverallEnum.Down]: {
    icon: CircleXmark,
    badgeLabel: "Сбой",
    bannerTitle: "Есть сбои",
    labelTheme: "danger",
    cardTheme: "danger",
  },
  [StatusResponseOverallEnum.Unknown]: {
    icon: CircleQuestion,
    badgeLabel: "Неизвестно",
    bannerTitle: "Статус неизвестен",
    labelTheme: "unknown",
    cardTheme: "normal",
  },
};

interface SeverityInfo {
  label: string;
  theme: LabelTheme;
}

export const severityInfo: Record<PublicAlertSeverityEnum, SeverityInfo> = {
  [PublicAlertSeverityEnum.Info]: { label: "Информация", theme: "info" },
  [PublicAlertSeverityEnum.Critical]: { label: "Критичный", theme: "danger" },
  [PublicAlertSeverityEnum.Warning]: {
    label: "Предупреждение",
    theme: "warning",
  },
};
